import React from 'react';
import styles from './LoadingModal.module.scss'


export function LoadingModal(props) {

  return (
    <div className={`${styles.LoadingModal} ${props.isLoading ? '' : 'd-none'}`}>
      <div className="mb-3">{props.text}</div>
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}